import useQueryParams from './useQueryParams';

export default function useQueryParam(parameter: string, transformer: (v: string) => any) {
  const queryParams = useQueryParams();
  const queryParam = queryParams.get(parameter);
  return transformer ? transformer(queryParam) : queryParam;
}
